import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getProducts = async () => {
    const { data, error } = await supabase
        .from('products')
        .select(`*`)

    if (error) {
        throw new Error(error.message)
    }

    return data
}

export default function useGetAllProducts() {
    return useQuery({
        queryKey: ['useGetAllProducts'],
        queryFn: () => getProducts(),
        staleTime: 0,
    })
}
